module.exports = __webpack_public_path__ + "img/放线菌.b11dc253.png";